module.exports = __webpack_public_path__ + "1811f8a4ec191bebb7e275bb970e30ca.png";